import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { BaseWebService } from "../shared/services/base-web.service";
import { SessionStorageService } from "../shared/services/session-storage.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class LogoutService {

    constructor(
        private _baseWebService: BaseWebService,
        private _sessionStorageService: SessionStorageService
    ) { }


    /**
     * function for login error.
     * @param  {Response|any} error error response.
     */
    handleError(error: Response | any) {
        this.clearStorage();
        return Observable.throw(error);
    }

    /**
     * service function for logout.
     * @returns Observable
     */
    logout = (): Observable<any> => {
        return this._baseWebService.request("v1/logout/", "delete")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * function to remove contents in localforage on logout.
     * @param  {any} data api token.
     */
    clearStorage = async () => {
        try {
            await this._sessionStorageService.clearItems();
        }
        catch (error) {
            return error;
        }
    }

}

